/* Fit native brand flyouts to the visible viewport without changing menu state. */
(() => {
  let scheduled = false;
  const fitVisibleLists = () => {
    scheduled = false;
    // Mobile already scrolls the whole native drawer; avoid nested scroll areas.
    if (window.innerWidth <= 1000 || document.documentElement.classList.contains('m2a')) return;
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    document.querySelectorAll('.mi-nav-item--brands .mi-brand-list').forEach(list => {
      const bounds = list.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const space = Math.max(80, Math.floor(viewportBottom - bounds.top - 16));
      list.style.setProperty('--mi-brand-panel-space', `${space}px`);
    });
  };
  const scheduleFit = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(fitVisibleLists);
  };
  const onMenuInteraction = event => {
    if (event.target instanceof Element && event.target.closest('.mi-nav-item--brands')) scheduleFit();
  };
  document.addEventListener('pointerover', onMenuInteraction);
  document.addEventListener('focusin', onMenuInteraction);
  document.addEventListener('click', onMenuInteraction);
  window.addEventListener('resize', scheduleFit, { passive: true });
  window.addEventListener('scroll', scheduleFit, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', scheduleFit);
})();
